import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom'; // change -- use routes in our application

const root = ReactDOM.createRoot(document.getElementById('root'));
//scrollRestoration = ???
root.render(
  <React.StrictMode>
    <BrowserRouter scrollRestoration="auto">
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// export?!
export {App as MyApp};
